import React from 'react';

const FCButton = (props) => {
  const { width, ready, type, children, style } = props;

  return (
    <button
      style={{ width: width, cursor: ready ? 'pointer' : 'not-allowed', ...style }}
      className='FCButton'
      type={type ? type : 'submit'}
    >
      {children}
    </button>
  );
};

export default FCButton;
